
import Panel from 'vux/src/components/panel/index.vue'


export default {
name: "Market",
components: {Panel},
data() {
return {
offset: 0,
seq: this.$route.params.seq,
market: [],
footer: {
title: '更多'
}
}
},
methods: {
pageChange() {
if (this.markettotal <= this.offset){
return
}
this.$http.get('/api/v1/normalrepairs/' + this.seq + '/list_repair_visible_to?role=ADMIN&offset=' + this.offset + '&count=20', {
headers: {
token: localStorage.getItem('token'),
opid: localStorage.getItem('userid')
}
}).then(response => {
response.data.content.forEach(item => {
this.market.push({title: item.name, desc: item.mobile})
})
this.offset += 20
}).catch(error => {
this.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
})
}
},
created() {
this.$http.get('/api/v1/normalrepairs/' + this.seq + '/list_repair_visible_to?role=ADMIN&offset=' + this.offset + '&count=20', {
headers: {
token: localStorage.getItem('token'),
opid: localStorage.getItem('userid')
}
}).then(response => {
response.data.content.forEach(item => {
this.market.push({title: item.name, desc: item.mobile})
})
this.markettotal = response.data.total
this.offset += 20
}).catch(error => {
this.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
})
}
}



// WEBPACK FOOTER //
// ./src/components/Market.vue